import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { HomepageImageListRequestBody, HomepageImageListResponse } from "../../core/api/requests/homepage_image/list/types";
import { HomepageImageCreateRequestBody, HomepageImageCreateResponse } from "../../core/api/requests/homepage_image/create/types";

const actionCreator = actionCreatorFactory("@@HomepageImage");

export const homepageImageActions = {
    fetchHomepageImage: actionCreator.async<CommonAsyncType<HomepageImageListResponse> & HomepageImageListRequestBody, HomepageImageListResponse>("FETCH_HOMEPAGE_IMAGE"),
    createNewHomepageImage: actionCreator.async<CommonAsyncType<HomepageImageCreateResponse> & HomepageImageCreateRequestBody, HomepageImageCreateResponse>("CREATE_NEW_HOMEPAGE_IMAGE"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}